import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LoanListNavUI from '../../../components/superUser/loanList/LoanListNavUI.js'

const ConditionSubsequentRemarksPageUI = ({ context, errorList, accountRemarkList, onRefreshClick }) =>
  <SuperUserPageSF context={context} className='pg_su_rp_lst' topnav='loans'
    headerText='Condition Subsequent Remarks' centered={!accountRemarkList && !errorList}
  >
    {
      !accountRemarkList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      accountRemarkList &&
      <div className='nav'>
        <LoanListNavUI page='remarks' />
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>Condition Subsequent Remarks</b></span>
            </span>
          }
          right={<span />}
        />
      </div>
    }
    {
      accountRemarkList && accountRemarkList.length !== 0 &&
      accountRemarkList.map((account, i) =>
        <ConditionSubsequentRemarksUI i={i}
          context={context} account={account}
          onRefreshClick={onRefreshClick}
        />
      )
    }

    {
      accountRemarkList && accountRemarkList.length === 0 &&
      <div className='g_m_top_50'>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No remarks yet'
        />
      </div>
    }

  </SuperUserPageSF>

const ConditionSubsequentRemarksUI = ({ context, account, i }) =>
  <div key={i}>
    {
      account.loanList.map((loan) =>
        <CardUI title={`${account.accountName}-${loan.loanName}`} className='g_m_bottom_100'>
          <div>
            {
              loan.remarkObjectList.map((object) =>
                <div className='g_flex_v'>
                  <span className='g_m_top_50'><b>{object.objectId}</b></span>
                  {
                    object.loanRemarksList.map((remarks) =>
                      <div>
                        <span className='g_muted'>{remarks.remarksDateF}:</span>
                        <span > {remarks.remarks}</span>
                      </div>
                    )}
                </div>
              )
            }
          </div>
        </CardUI>
      )
    }
  </div>

export default ConditionSubsequentRemarksPageUI
